export default __webpack_public_path__ + "static/media/factura.fa96e2b2.svg";